import { useCallback } from 'react';
import { ControllerRenderProps, UseFormReturn } from 'react-hook-form';
import { useOnFieldDisabled } from './use-on-field-disabled/useOnFieldDisabled';

/**
 * Hook con un effect che reimposta il valore di un booleano
 * (opzione) a `false` quando viene disabilitato.
 * Non possiamo usare `useResetDefaultOnDisableEffect` perché
 * utilizzerebbe il default dallo schema
 */
export function useResetOptionToFalseOnDisable(
  field: ControllerRenderProps<any, string>,
  enabled: boolean | undefined,
  groupEnabled: boolean,
) {
  const reset = useCallback(
    (methods: UseFormReturn, fieldName: string) => {
      if (!groupEnabled) return;
      // console.log(`resetto l'opzione ${fieldName} a false (singola option)`);
      methods.setValue(fieldName, false, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    },
    [groupEnabled],
  );

  useOnFieldDisabled(field, enabled, reset);
}
